<mat-tab-group>

    <mat-tab label="Recibos" *appRole="['Comprobantes.Ver']">
        <br>
        <app-listado-comprobantes-recibos></app-listado-comprobantes-recibos>
    </mat-tab>
    <mat-tab label="Liquidaciones" *appRole="['Comprobantes.Ver']">
        <br>
        <app-listado-comprobantes-liquidaciones></app-listado-comprobantes-liquidaciones>
    </mat-tab>
    <!-- Las mismas liquidaciones, pero agrupadas por la transferencia que se le
         hace a cada propietario: una fila por propietario y fecha, sin importar
         cuántas propiedades se le hayan liquidado. -->
    <mat-tab label="Transferencias" *appRole="['Comprobantes.Trasferencias.Ver']">
        <br>
        <app-listado-transferencias-propietario></app-listado-transferencias-propietario>
    </mat-tab>
    <mat-tab label="Caja" *appRole="['ComprobantesCaja.Ver']">
        <br>
        <app-listado-comprobantes-genericos></app-listado-comprobantes-genericos>
    </mat-tab>
    <mat-tab label="Acreditaciones" *appRole="['Acreditaciones.Ver']">
        <br>
        <app-listado-acreditaciones></app-listado-acreditaciones>
    </mat-tab>
</mat-tab-group>
